import { ICopyable } from '../controls/common/icopyable';
import { ViewType } from './enums/view-type';
import { IDisplayableItem } from './interfaces/displayable-item.interface';
import { IView } from './interfaces/view.interface';

export class View implements ICopyable<View>, IDisplayableItem {
    id: number = null;
    name: string = null;
    viewType: ViewType = null;
    organizationId: string;
    defaultSendingAddressId: number = null;
    parentId: number = null;
    isArchive: boolean;
    updateDate: Date = null;
    archivingEnabled: boolean = false;
    delayBeforeArchiving: number = null;
    smsOadc: string = null;

    get editableId(): string | number {
        return this['id'];
    }

    public createCopy(): View {
        const instance = new View();
        instance.id = this.id;
        instance.name = this.name;
        instance.viewType = this.viewType;
        instance.organizationId = this.organizationId;
        instance.defaultSendingAddressId = this.defaultSendingAddressId;
        instance.parentId = this.parentId;
        instance.isArchive = this.isArchive;
        instance.updateDate = this.updateDate;
        instance.archivingEnabled = this.archivingEnabled;
        instance.delayBeforeArchiving = this.delayBeforeArchiving;
        instance.smsOadc = this.smsOadc;

        return instance;
    }

    public static createFormCopy(view: View): IView {
        const instance = new View();
        instance.id = view.id;
        instance.name = view.name;
        instance.viewType = view.viewType;
        instance.organizationId = view.organizationId;
        instance.defaultSendingAddressId = view.defaultSendingAddressId;
        instance.parentId = view.parentId;
        instance.isArchive = view.isArchive;
        instance.updateDate = view.updateDate;
        instance.archivingEnabled = view.archivingEnabled;
        instance.delayBeforeArchiving = view.delayBeforeArchiving;
        instance.smsOadc = view.smsOadc;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.name = other.name;
        this.viewType = other.viewType;
        this.organizationId = other.organizationId;
        this.defaultSendingAddressId = other.defaultSendingAddressId;
        this.parentId = other.parentId;
        this.isArchive = other.isArchive;
        this.updateDate = other.updateDate;
        this.archivingEnabled = other.archivingEnabled;
        this.delayBeforeArchiving = other.delayBeforeArchiving;
        this.smsOadc = other.smsOadc;
    }

    /**
     * Retourne une instance de View à partir d'une instance de IView.
     * @param other : Instance de IView.
     * @returns : Instance de View.
     */
    public static from(other: IView) {
        if (!!other) {
            const instance = new View();

            instance.id = other.id;
            instance.name = other.name;
            instance.viewType = other.viewType;
            instance.defaultSendingAddressId = other.defaultSendingAddressId;
            instance.parentId = other.parentId;
            instance.isArchive = other.isArchive;
            instance.updateDate = other.updateDate;
            instance.archivingEnabled = other.archivingEnabled;
            instance.delayBeforeArchiving = other.delayBeforeArchiving;
            instance.smsOadc = other.smsOadc;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne un tableau d'instances de View à partir d'un tableau d'instances de IView.
     * @param other : Tableau d'instances de IView.
     * @returns : Tableau d'instances de View.
     */
    public static fromArray(others: IView[]) {
        if (!!others) {
            let views: View[] = [];

            others.forEach((x) => {
                const view = View.from(x);
                views.push(view);
            });

            return views;
        } else {
            return null;
        }
    }

    public getDisplayName() {
        return `${this.name}`;
    }

    get displayName(): string {
        return `${this.name}`;
    }
}
